import React from 'react'
import { cloneDeep } from 'lodash/lang'
import { NO_NONE_NOPES } from '../camperConstants'

const withAllergyEventHandlers = WrappedComponent => {
  return props => {
    const {
      form, // via redux state
      setCamperFormField, // via redux actions
      setFormErrors
    } = props

    const handleChangeCustomAllergyField = fieldName => event => {
      const parts = fieldName.split("_");
      const food = parts[2] === 'food'
      const severe = parts[3] === "severe";
      const name = event.target && event.target.value
      if (NO_NONE_NOPES.includes(name.toLowerCase().trim())) {
        setCamperFormField('noNopeWarning', true)
        setFormErrors({[fieldName]: 'If there is no allergy, please leave blank'})
      } else {
        setCamperFormField('noNopeWarning', false)
        setFormErrors({[fieldName]: ''})
      }
      const custom = true
      const allergies = cloneDeep(form.camperAllergies)

      const existing = allergies.find(
        a => a.custom && a.food === food && a.severe === severe
      )

      if (existing) {
        existing.name = name
      } else {
        allergies.push({
          name,
          custom,
          severe,
          food
        })
      }

      setCamperFormField('camperAllergies', allergies)
      setCamperFormField(fieldName, name)
    }

    const handleChangeStandardAllergyField = ({ name, food }) => event => {
      // convert string values to boolean
      const severe = JSON.parse(event.target.value)
      const allergies = cloneDeep(form.camperAllergies)
      const custom = false

      const existing = allergies.find(
        a => !a.custom && a.food === food && a.name === name
      )
      if (existing) {
        existing.severe = severe
      } else {
        allergies.push({
          name,
          custom,
          severe,
          food
        })
      }

      setCamperFormField('camperAllergies', allergies)
    }

    return (
      <WrappedComponent
        onChangeStandardAllergyField={handleChangeStandardAllergyField}
        onChangeCustomAllergyField={handleChangeCustomAllergyField}
        {...props}
      />
    )
  }
}

export default withAllergyEventHandlers
